import { observable, makeObservable, action } from 'mobx';
import { api } from '../../constants/apis';
import { deleteRequest, get, post, put } from '../../utils/axios-requests';

export default class CardsUiStore {
  @observable error: string = '';
  @observable context: any = null;
  @observable loading: boolean = false;
  @observable cards: Array<any> = [];

  constructor() {
    makeObservable(this);
  }

  @action
  public initliazeContext = (context: any) => {
    this.context = context;
  };

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public fetchCards = async () => {
    try {
      const res = await get(api.cards.user, {
        userId: this.context.authenticatedUser.id,
      });

      this.cards = res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public updateCardSettings = async (cardId: string, body: any) => {
    try {
      await put(api.cards.privacy, body, { cardId });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public createCard = async (name: string, isPublic: boolean) => {
    try {
      const res = await post(api.cards.user, {
        name,
        isPublic,
      });

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public deleteCard = async (cardId: string) => {
    try {
      await deleteRequest(api.cards.card, {
        cardId,
      });

      this.fetchCards();
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };
}
